import { createContext, useContext, useState, type ReactNode } from 'react';

export type Tab = 'map' | 'coverage' | 'search' | 'door' | 'coord' | 'profile' | 'admin' | 'help';

interface Nav {
  tab: Tab;
  setTab: (t: Tab) => void;
  currentDoor: string | null; // household id open at the door
  openDoor: (householdId: string) => void;
  setCurrentDoor: (id: string | null) => void;
  goBack: () => void; // previous door (swipe-right)
  canGoBack: boolean;
}

const Ctx = createContext<Nav | null>(null);
export const useNav = () => {
  const v = useContext(Ctx);
  if (!v) throw new Error('useNav outside provider');
  return v;
};

export function NavProvider({ children, initial = 'map' }: { children: ReactNode; initial?: Tab }) {
  const [tab, setTab] = useState<Tab>(initial);
  const [currentDoor, setCurrentDoor] = useState<string | null>(null);
  const [history, setHistory] = useState<string[]>([]);

  const openDoor = (householdId: string) => {
    setHistory((h) => (currentDoor && currentDoor !== householdId ? [...h, currentDoor] : h));
    setCurrentDoor(householdId);
    setTab('door');
  };

  const goBack = () => {
    setHistory((h) => {
      if (!h.length) return h;
      setCurrentDoor(h[h.length - 1]!);
      return h.slice(0, -1);
    });
  };

  return (
    <Ctx.Provider
      value={{ tab, setTab, currentDoor, openDoor, setCurrentDoor, goBack, canGoBack: history.length > 0 }}
    >
      {children}
    </Ctx.Provider>
  );
}
